/**
 * GALATEA SIGNATURE - HELPER SOBERANO DE LOGOS (GALATEA + TENANTS)
 * Fonte Única de Verdade: Banco de Dados PostgreSQL galatea_auth (coluna tema_config.ui.logoUrl)
 * Armazenamento Oficial: AWS S3 + CloudFront CDN
 */

export function getGalateaLogoUrl(): string {
  return '/logo-galatea.png?v=20260915_v3';
}

export interface TenantLogoTarget {
  logo_url?: string | null;
  preferencias?: any;
  banco_dados?: string | null;
  nome_empresa?: string | null;
  empresa_nome?: string | null;
  empresa_id?: number | null;
  id_empresa?: number | null;
  id?: number | null;
}

const S3_BASE = 'https://galatea-branding-prod.s3.sa-east-1.amazonaws.com';

export function getTenantLogoUrl(empresa?: TenantLogoTarget | null): string | null {
  if (!empresa) return null;

  // 1. URL explícita salva no galatea_auth (coluna tema_config.ui.logoUrl)
  if (empresa.logo_url) return empresa.logo_url;
  if (empresa.preferencias?.ui?.logoUrl) return empresa.preferencias.ui.logoUrl;

  // 2. Resolver por empresa_id / id_empresa no S3
  const empId = empresa.empresa_id || empresa.id_empresa || empresa.id;
  if (empId) {
    return `${S3_BASE}/branding/${empId}/logo.jpg`;
  }

  // 3. Fallback por nome/chave de banco no S3
  const key = (empresa.banco_dados || empresa.nome_empresa || empresa.empresa_nome || '').toLowerCase().trim();
  if (key.includes('attuante')) return `${S3_BASE}/branding/attuante/logo.jpg`;
  if (key.includes('aragon')) return `${S3_BASE}/branding/aragon/logo.jpg`;
  if (key.includes('blue')) return `${S3_BASE}/branding/blue/logo.jpg`;
  if (key.includes('brlight')) return `${S3_BASE}/branding/brlight/logo.jpg`;
  if (key.includes('ecotech')) return `${S3_BASE}/branding/ecotech/logo.jpg`;
  if (key.includes('sulcomp') || key.includes('sul')) return `${S3_BASE}/branding/sulcomp/logo.jpg`;
  if (key.includes('solution')) return `${S3_BASE}/branding/solution/logo.jpg`;
  if (key.includes('tavares')) return `${S3_BASE}/branding/tavares/logo.jpg`;
  if (key.includes('kupper')) return `${S3_BASE}/branding/kupper/logo.jpg`;
  if (key.includes('mercadao')) return `${S3_BASE}/branding/mercadao/logo.jpg`;
  if (key.includes('multinst')) return `${S3_BASE}/branding/multinst/logo.jpg`;
  if (key.includes('comfitas')) return `${S3_BASE}/branding/comfitas/logo.jpg`;
  if (key.includes('rb')) return `${S3_BASE}/branding/rb/logo.jpg`;

  return null;
}
